import React from 'react'
import PropTypes from 'prop-types'
import { SmartImage } from 'shared/UI/SmartImage'
import { authorization_password_page_image } from 'common/images/remote/urls.json'
import isEmpty from 'lodash/isEmpty'

import './style.css.scss'

const PasswordImage = (props) => {
  const imageUrl = isEmpty(props.imageUrl) ? authorization_password_page_image : props.imageUrl

  return(
    <div className='password-image-box'>
      <SmartImage
        config={{url: imageUrl}}
        className="authorization-page-image"/>
    </div>
  )
}

PasswordImage.propTypes = {
  imageUrl: PropTypes.string
}

export default PasswordImage
